(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.headerHeight = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
      document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);

      window.addEventListener('resizeend', () => {
        // Only update height once per resize cycle, off the main thread
        requestAnimationFrame(() => {
          this.headerHeight = this.header.offsetHeight;
          document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
          document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);
        });
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.searchButton = this.querySelector('.header__icon--search');
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
      }

      this.createObserver();
    }

    searchButtonClick() {
      this.preventHide = true;
      requestAnimationFrame(() => (this.preventHide = false));
    }

    // Defer the DOM write to avoid synchronous reflow
    setHeaderHeightLive(event, zero) {
      requestAnimationFrame(() => {
        const isVisible = !this.header.classList.contains('shopify-section-header-hidden');
        const height = (zero || !isVisible) ? 0 : this.header.offsetHeight;
        document.documentElement.style.setProperty('--header-height-live', `${height}px`);
      });
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        // Only trigger actions if the scroll has changed by at least the threshold value
        if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;

        const scrollDifference = scrollTop - this.currentScrollTop;
        // Handle scrolling classes based on 50px sensitivity
        if (scrollDifference > 50 && this.pauseScrollListen !== true) {
          // Scrolling down
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-down');
          this.header.classList.remove('scrolling-up');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
          // Scrolling up
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-up');
          this.header.classList.remove('scrolling-down');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling down
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling up
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          // Reset at the top
          this.header.classList.remove('scrolled-past-header');
          this.header.classList.remove('scrolling-down');
          this.header.classList.remove('scrolling-up');
          requestAnimationFrame(this.reset.bind(this));
          setTimeout(() => {
            this.setHeaderHeightLive();
          }, 320);
        }

        this.currentScrollTop = scrollTop;
        this.lastScrollTrigger = scrollTop; // Update the last scroll position that triggered an action
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, true);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["truck-catalog"] && !Shopify.designMode) return;
  try {
    

const initializeTruckCatalog = async (catalog) => {
  if (catalog.dataset.filtersReady) return;
  catalog.dataset.filtersReady = 'true';
  const panel = catalog.querySelector('[data-truck-panel]');
  const mobile = window.matchMedia('(max-width:989px)');
  const updatePanel = () => {
    panel.open = !mobile.matches;
    panel.querySelector('summary').tabIndex = mobile.matches ? 0 : -1;
  };
  updatePanel();
  mobile.addEventListener('change', updatePanel);
  const grid = catalog.querySelector('[data-truck-grid]');
  const count = catalog.querySelector('[data-truck-count]');
  const empty = catalog.querySelector('[data-truck-empty]');
  const loading = catalog.querySelector('[data-filter-loading]');
  const pages = new Set([catalog.dataset.catalogPage]);
  const queued = new Set();
  const queue = [];
  const enqueue = (root) => {
    [root.dataset.catalogPrevious, root.dataset.catalogNext].filter(Boolean).forEach((path) => {
      const url = new URL(path, location.href);
      if (url.origin !== location.origin) throw new Error('Invalid catalog page');
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      if (!queued.has(url.href)) { queued.add(url.href); queue.push(url.href); }
    });
  };
  try {
    enqueue(catalog);
    const fragment = document.createDocumentFragment();
    while (queue.length) {
      const response = await fetch(queue.shift());
      if (!response.ok) throw new Error('Catalog page unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const page = [...doc.querySelectorAll('.truck-catalog')].find((item) => item.dataset.catalogId === catalog.dataset.catalogId);
      if (!page) throw new Error('Catalog missing');
      if (pages.has(page.dataset.catalogPage)) continue;
      pages.add(page.dataset.catalogPage);
      page.querySelectorAll('[data-truck-card]').forEach((card) => fragment.append(card));
      enqueue(page);
    }
    grid.append(fragment);
    const pagination = catalog.querySelector('.truck-catalog__pagination');
    if (pagination) pagination.hidden = true;
  } catch (error) {
    loading.hidden = true;
    catalog.querySelector('[data-filter-error]').hidden = false;
    return;
  }
  const cards = [...catalog.querySelectorAll('[data-truck-card]')];
  const pdfButton = catalog.querySelector('[data-truck-pdf]');
  const compactButton = catalog.querySelector('[data-truck-compact]');
  const downloadCatalog = (compact = false) => {
    filter();
    const selectedCards = cards.filter((card) => !card.hidden);
    if (!selectedCards.length) return;
    const output = window.open('', '_blank');
    if (!output) return;
    const doc = output.document;
    doc.title = compact ? 'NLT-Catalogo-Compacto' : 'NLT-Catalogo-Camiones';
    doc.documentElement.lang = document.documentElement.lang;
    const style = doc.createElement('style');
    style.textContent = "@page{size:A4;margin:12mm}*{box-sizing:border-box}body{font-family:Arial,sans-serif;color:#252c30;margin:0 auto;max-width:820px;padding:24px;background:#e9ebed;-webkit-print-color-adjust:exact;print-color-adjust:exact}article{background:white;padding:24px;margin-bottom:24px;break-before:page}article:first-of-type{break-before:auto}header{display:flex;justify-content:space-between;gap:16px;align-items:center;border-bottom:4px solid #ce1426;padding:0 0 12px;margin-bottom:20px}.brand{font-size:30px;font-weight:900;font-style:italic;color:#ce1426;letter-spacing:-1px}.brand small{display:block;color:#303b40;font-size:10px;letter-spacing:2px;font-style:normal}.edition{font-size:10px;text-align:right;line-height:1.6;color:#58636a}h2{font-size:28px;line-height:1.1;margin:0 0 10px}.meta{font-size:11px;color:#58636a;margin:0 0 16px}.photo{display:block;width:100%;height:350px;object-fit:contain;background:#f3f4f5;border-radius:6px;margin-bottom:16px}.price{color:#c81020;font-size:25px;font-weight:800;padding:10px 0 14px;border-bottom:1px solid #d9dfe2;margin-bottom:12px}.specs{display:grid;grid-template-columns:1fr 1fr;column-gap:24px;margin:0 0 16px}.spec{display:flex;justify-content:space-between;gap:12px;border-bottom:1px solid #e3e6e8;padding:8px 0;break-inside:avoid;min-width:0}.spec dt{font-size:9px;text-transform:uppercase;letter-spacing:.5px;color:#67737a}.spec dd{margin:0;font-size:11px;font-weight:700;text-align:right;overflow-wrap:anywhere}.spec.wide{grid-column:1/-1;display:block}.spec.wide dd{text-align:left;white-space:pre-wrap;font-weight:400;line-height:1.5;margin-top:6px}footer{display:flex;justify-content:space-between;gap:16px;border-top:3px solid #303b40;padding-top:12px;font-size:10px;line-height:1.7}footer a{color:#bc1121;font-weight:700;text-decoration:none}button{padding:14px 22px;background:#c81020;color:white;border:0;border-radius:4px;font-size:16px;cursor:pointer;margin-bottom:18px}.hint{font-size:13px}button:disabled{opacity:.5}@media print{body{padding:0;max-width:none;background:white}article{padding:0;margin:0;min-height:260mm}button,.hint{display:none}}";
    if (compact) style.textContent += '.compact-sheet{display:grid;grid-template-columns:1fr 1fr;gap:6mm;break-before:page;margin:0 0 6mm}.compact-sheet:first-of-type{break-before:auto}.compact-sheet article{display:flex;flex-direction:column;min-width:0;min-height:0;break-before:auto;break-inside:avoid;margin:0;padding:4mm;border:1px solid #dce1e4;border-radius:6px}.compact-sheet header{margin-bottom:8px;padding-bottom:6px;border-bottom-width:2px;gap:8px}.compact-sheet .brand{font-size:20px}.compact-sheet .brand small{font-size:6px;letter-spacing:1px}.compact-sheet .edition{font-size:7px}.compact-sheet h2{font-size:17px;line-height:1.15;margin-bottom:5px}.compact-sheet .meta{font-size:8px;margin:0 0 7px}.compact-sheet .photo{height:45mm;margin-bottom:6px}.compact-sheet .price{font-size:17px;margin-bottom:6px;padding:3px 0 7px}.compact-sheet .specs{gap:4px 10px;margin:0 0 8px}.compact-sheet .spec{display:block;padding:3px 0}.compact-sheet .spec dt{font-size:7px;letter-spacing:0}.compact-sheet .spec dd{font-size:10px;text-align:left;margin-top:3px}.compact-sheet footer{margin-top:auto;flex-wrap:wrap;gap:3px 8px;padding-top:6px;font-size:8px;border-top-width:1px}.compact-sheet footer div{width:100%}@media print{.compact-sheet{height:270mm;margin:0;grid-template-rows:repeat(2,minmax(0,1fr))}.compact-sheet article{min-height:0;padding:4mm}}';
    if (compact) style.textContent += '.compact-sheet{background:linear-gradient(135deg,#dfe4e7 0%,#f3f5f6 45%,#e6eaed 100%);padding:3mm;gap:5mm;border-top:3px solid #c91523;border-bottom:3px solid #26343d}.compact-sheet article{position:relative;background:linear-gradient(145deg,transparent 94%,#c91523 94%,#c91523 95%,#26343d 95%),#fff;border:1px solid #cdd5da;border-radius:5px;box-shadow:0 2px 8px #20303c12}.compact-sheet header{background:linear-gradient(115deg,#23323c 0%,#354652 78%,#c91523 78%,#c91523 81%,#23323c 81%);border:0;border-radius:3px;padding:8px 9px;color:white}.compact-sheet .brand{color:#fff}.compact-sheet .brand small{color:#dde4e9}.compact-sheet .edition{color:#eef2f4;max-width:57%;padding-right:4px}.compact-sheet .meta{color:#596b77}.compact-sheet .photo{background:#edf0f2;border:1px solid #e0e5e8;border-radius:4px}.compact-sheet .price{border-bottom:2px solid #c91523}.compact-sheet .specs{background:#f1f4f6;border:1px solid #e4e9ec;border-radius:4px;padding:5px 7px}.compact-sheet .spec{border-bottom-color:#dce3e8}.compact-sheet footer{border-top:1px solid #b9c5cd;padding-right:14px}.compact-sheet footer a{color:#b31522}@media print{.compact-sheet{height:270mm;-webkit-print-color-adjust:exact;print-color-adjust:exact}.compact-sheet article{box-shadow:none}}';
    doc.head.append(style);
    const save = doc.createElement('button');
    save.textContent = compact ? compactButton.textContent : pdfButton.textContent;
    save.addEventListener('click', () => output.print());
    doc.body.append(save);
    const hint = doc.createElement('p');
    hint.className = 'hint';
    hint.textContent = pdfButton.dataset.pdfHint;
    doc.body.append(hint);
    const images = [];
    let compactSheet;
    selectedCards.forEach((card, index) => {
      const article = doc.createElement('article');
      const header = doc.createElement('header');
      const brand = doc.createElement('div');
      brand.className = 'brand';
      brand.textContent = 'NLT';
      const subtitle = doc.createElement('small');
      subtitle.textContent = 'REFACCIONES';
      brand.append(subtitle);
      const edition = doc.createElement('div');
      edition.className = 'edition';
      edition.textContent = catalog.querySelector('h1').textContent + ' · ' + new Date().toLocaleDateString('es-MX');
      header.append(brand, edition);
      article.append(header);
      const heading = doc.createElement('h2');
      heading.textContent = card.querySelector('h2').textContent;
      const meta = doc.createElement('p');
      meta.className = 'meta';
      meta.textContent = card.querySelector('.truck-card__status').textContent.trim() + ' · ' + card.querySelector('.truck-card__topline').textContent.trim().replace(/\s+/g, ' ');
      article.append(heading, meta);
      const source = card.querySelector('.truck-card__media img');
      if (source) {
        const photo = doc.createElement('img');
        photo.className = 'photo';
        photo.alt = heading.textContent;
        const loaded = new Promise(resolve => {photo.onload = resolve;photo.onerror = resolve;});
        photo.src = source.src;
        article.append(photo);
        images.push(loaded);
      }
      const lines = (card.dataset.pdfDetails || '').trim().split('\n').filter(line => line.trim());
      const price = doc.createElement('div');
      price.className = 'price';
      price.textContent = (lines[1] || '').replace(/^[^:]+:\s*/, '');
      article.append(price);
      const specs = doc.createElement('dl');
      specs.className = 'specs';
      let lastValue;
      lines.slice(2).forEach(line => {
        if (/^https?:\/\//.test(line.trim())) return;
        const colon = line.indexOf(':');
        if (colon < 0) {if (lastValue) lastValue.textContent += '\n' + line;return;}
        const label = line.slice(0, colon).trim();
        if (['Estado', 'Stock'].includes(label)) return;
        const row = doc.createElement('div');
        row.className = 'spec' + (label === 'Descripción' ? ' wide' : '');
        const name = doc.createElement('dt');
        name.textContent = label;
        const value = doc.createElement('dd');
        value.textContent = line.slice(colon + 1).trim();
        if (label === 'Odómetro') value.textContent = value.textContent.replace(/^\d+/, number => Number(number).toLocaleString('en-US'));
        row.append(name, value);
        specs.append(row);
        lastValue = value;
      });
      if (compact) {
        specs.replaceChildren();
        card.querySelectorAll('.truck-card__highlights > div').forEach(highlight => {
          const row = doc.createElement('div');row.className = 'spec';
          const name = doc.createElement('dt');name.textContent = highlight.querySelector('dt').textContent;
          const value = doc.createElement('dd');value.textContent = highlight.querySelector('dd').textContent;
          row.append(name, value);specs.append(row);
        });
      }
      article.append(specs);
      const footer = doc.createElement('footer');
      const contact = doc.createElement('div');
      contact.textContent = 'NLT Refacciones · +52 625 111 1643';
      const link = doc.createElement('a');
      link.href = card.querySelector('h2 a').href;
      link.textContent = card.querySelector('.truck-card__details-link').textContent + ' →';
      const page = doc.createElement('span');
      page.textContent = (index + 1) + ' / ' + selectedCards.length;
      footer.append(contact, link, page);
      article.append(footer);
      if (compact) {
        if (index % 4 === 0) {compactSheet = doc.createElement('section');compactSheet.className = 'compact-sheet';doc.body.append(compactSheet);}
        compactSheet.append(article);
      } else doc.body.append(article);
    });
    save.disabled = true;
    Promise.all(images).then(() => {if(!output.closed){save.disabled = false;output.focus();output.print();}});
  };
  pdfButton.addEventListener('click', () => downloadCatalog(false));
  compactButton.addEventListener('click', () => downloadCatalog(true));

  const search = catalog.querySelector('[data-truck-search]');
  const min = catalog.querySelector('[data-truck-price-min]');
  const max = catalog.querySelector('[data-truck-price-max]');
  const normalize = (value) => value.trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const groups = [...catalog.querySelectorAll('[data-truck-facet]')];
  const records = cards.map((card) => ({
    card,
    text: normalize(card.textContent + ' ' + Object.values(card.dataset).join(' ')),
    fields: Object.fromEntries(groups.map((group) => [group.dataset.truckFacet, normalize(card.getAttribute('data-' + group.dataset.truckFacet) || '')])),
    price: card.dataset.price.trim() === '' ? null : Number(card.dataset.price)
  }));
  groups.forEach((group) => {
    const key = group.dataset.truckFacet;
    const labels = new Map();
    cards.forEach((card) => {
      const label = (card.getAttribute('data-' + key) || '').trim();
      if (label) labels.set(normalize(label), label);
    });
    [...labels].sort((a, b) => key === 'year' ? Number(b[0]) - Number(a[0]) : a[1].localeCompare(b[1], undefined, {numeric:true})).forEach(([value, text]) => {
      const label = document.createElement('label');
      const checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.value = value;
      checkbox.dataset.facet = key;
      const name = document.createElement('span');
      name.textContent = key === 'status' ? text.charAt(0).toUpperCase() + text.slice(1) : text;
      const total = document.createElement('span');
      total.className = 'truck-catalog__option-count';
      label.append(checkbox, name, total);
      group.append(label);
    });
    group.closest('details').hidden = labels.size === 0;
  });
  const filter = () => {
    const selected = Object.fromEntries(groups.map((group) => [group.dataset.truckFacet, [...group.querySelectorAll('input:checked')].map((input) => input.value)]));
    const term = normalize(search.value);
    const low = min.value === '' ? null : Number(min.value);
    const high = max.value === '' ? null : Number(max.value);
    const matches = (record, except) => (!term || record.text.includes(term)) &&
      (low === null || (record.price !== null && record.price >= low)) &&
      (high === null || (record.price !== null && record.price <= high)) &&
      Object.entries(selected).every(([key, values]) => key === except || !values.length || values.includes(record.fields[key]));
    let visible = 0;
    records.forEach((record) => { record.card.hidden = !matches(record); if (!record.card.hidden) visible++; });
    count.textContent = visible;
    pdfButton.disabled = visible === 0;
    compactButton.disabled = visible === 0;
    empty.hidden = visible !== 0 || records.length === 0;
    groups.forEach((group) => {
      const key = group.dataset.truckFacet;
      const badge = catalog.querySelector('[data-facet-selected="' + key + '"]');
      badge.textContent = selected[key].length ? '(' + selected[key].length + ')' : '';
      group.querySelectorAll('input').forEach((input) => {
        const total = records.filter((record) => record.fields[key] === input.value && matches(record, key)).length;
        input.parentElement.querySelector('.truck-catalog__option-count').textContent = '(' + total + ')';
      });
    });
  };
  catalog.querySelector('.truck-catalog__filters').addEventListener('input', filter);
  catalog.querySelectorAll('[data-truck-reset]').forEach((button) => button.addEventListener('click', () => {
    search.value = ''; min.value = ''; max.value = '';
    catalog.querySelectorAll('[data-facet]').forEach((input) => { input.checked = false; });
    filter();
  }));
  filter();
  loading.hidden = true;
  catalog.querySelector('fieldset').disabled = false;
};
const initializeTruckCatalogs = (root) => root.querySelectorAll('.truck-catalog').forEach(initializeTruckCatalog);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeTruckCatalogs(document));
else initializeTruckCatalogs(document);
document.addEventListener('shopify:section:load', (event) => initializeTruckCatalogs(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["truck-detail"]) return;
  try {
    
document.querySelectorAll('[data-truck-gallery]').forEach((gallery) => {
  const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
  const thumbnails = Array.from(gallery.querySelectorAll('[data-gallery-thumbnail]'));
  const thumbnailStrip = gallery.querySelector('[data-gallery-thumbnails]');
  const previous = gallery.querySelector('[data-gallery-previous]');
  const next = gallery.querySelector('[data-gallery-next]');
  const lightbox = gallery.querySelector('[data-gallery-lightbox]');
  const lightboxImage = gallery.querySelector('[data-lightbox-image]');
  const lightboxPrevious = gallery.querySelector('[data-lightbox-previous]');
  const lightboxNext = gallery.querySelector('[data-lightbox-next]');
  const lightboxClose = gallery.querySelector('[data-gallery-close]');
  let current = 0;

  const show = (index) => {
    current = (index + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => {
      const active = slideIndex === current;
      slide.hidden = !active;
      slide.classList.toggle('is-active', active);
    });
    thumbnails.forEach((thumbnail, thumbnailIndex) => {
      const active = thumbnailIndex === current;
      thumbnail.classList.toggle('is-active', active);
      if (active) {
        thumbnail.setAttribute('aria-current', 'true');
        if (thumbnailStrip) {
          const stripBounds = thumbnailStrip.getBoundingClientRect();
          const thumbnailBounds = thumbnail.getBoundingClientRect();
          thumbnailStrip.scrollBy({
            left: thumbnailBounds.left - stripBounds.left - (thumbnailStrip.clientWidth - thumbnailBounds.width) / 2,
            behavior: 'smooth'
          });
        }
      } else {
        thumbnail.removeAttribute('aria-current');
      }
    });
    if (lightbox.open) {
      const activeImage = slides[current].querySelector('img');
      lightboxImage.removeAttribute('srcset');
      lightboxImage.removeAttribute('sizes');
      lightboxImage.src = slides[current].href;
      lightboxImage.alt = activeImage.alt;
    }
  };

  const openLightbox = (index) => {
    show(index);
    const activeImage = slides[current].querySelector('img');
    lightboxImage.removeAttribute('srcset');
    lightboxImage.removeAttribute('sizes');
    lightboxImage.src = slides[current].href;
    lightboxImage.alt = activeImage.alt;
    lightbox.showModal();
  };

  thumbnails.forEach((thumbnail) => {
    thumbnail.addEventListener('click', () => show(Number(thumbnail.dataset.galleryThumbnail)));
  });
  previous.addEventListener('click', () => show(current - 1));
  next.addEventListener('click', () => show(current + 1));
  slides.forEach((slide, index) => {
    slide.addEventListener('click', (event) => {
      event.preventDefault();
      openLightbox(index);
    });
  });
  lightboxPrevious.addEventListener('click', () => show(current - 1));
  lightboxNext.addEventListener('click', () => show(current + 1));
  lightboxClose.addEventListener('click', () => lightbox.close());
  lightbox.addEventListener('click', (event) => {
    if (event.target === lightbox) lightbox.close();
  });
  lightbox.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') show(current - 1);
    if (event.key === 'ArrowRight') show(current + 1);
  });

  if (slides.length < 2) {
    previous.hidden = true;
    next.hidden = true;
    lightboxPrevious.hidden = true;
    lightboxNext.hidden = true;
  }
});

  } catch(e) { console.error(e); }
})();
})();
